import JsSIP from 'jssip';
import { prefix } from 'src/config';
import { l } from 'src/utils';

JsSIP.debug.enable('JsSIP:*'); // Включаем полный дебаг, хотя он, кажется, включен по дефолту.
let localClonedStream = null;

const configuration = { // Конфигурация.
  pcConfig: { iceServers: [] },
  mediaConstraints: { // https://www.rtcmulticonnection.org/docs/mediaConstraints/
    audio: true, // Принимает только аудио.
    video: false,
  },
  rtcOfferConstraints: { // https://jssip.net/documentation/3.4.x/api/session/ как я понял, отвечает за реинвайты
    offerToReceiveAudio: true, // Принимаем только аудио
    offerToReceiveVideo: false,
  },
};

function answer(remoteAudioControl) {
  // Answer call
  window.sipSession.answer(configuration);
  window.sipSession.connection.ontrack = (e) => {
    l.log('addstream(track) REMOTE');
    l.dir(e);
    // set remote audio stream (to listen to remote audio)
    // remoteAudioControl is <audio> element on page
    [remoteAudioControl.srcObject] = e.streams;
    remoteAudioControl.play();
  };
}
function hangUp() {
  window.sipSession.terminate();
  JsSIP.Utils.closeMediaStream(localClonedStream);
}

function playSound(soundName, loop, soundsControl) {
  soundsControl.pause();
  soundsControl.currentTime = 0.0;
  soundsControl.src = `${prefix}/music/${soundName}`;
  soundsControl.loop = loop;
  soundsControl.play();
}

function stopSound(soundsControl) {
  soundsControl.pause();
  soundsControl.currentTime = 0.0;
}

async function login({
  answerCallback, hangupCallback, incomingCallback,
  soundsControl, remoteAudioControl,
}) {
  const sipUrlFull = window.$store.state.user.sipUrl;
  const { sipPassword } = window.$store.state.user;
  const [sipUserPart, domainAndPort] = sipUrlFull.split('@');
  const [domain, port] = domainAndPort.split(':');
  l.log('on login');

  window.localStorage.setItem('login', sipUserPart);
  window.localStorage.setItem('pwd', sipPassword);
  const socket = new JsSIP.WebSocketInterface(`wss://${domain}:${port}`);
  l.warn('Socket connected', socket);
  const ua = new JsSIP.UA({
    uri: `sip:${sipUserPart}@${domain}`, // прописан домен для логина
    password: sipPassword,
    display_name: sipUserPart,
    session_timers: false,
    sockets: [socket],
  });
  window.ua = ua;

  // соединяемся с freeswitch
  window.ua.on('connecting', () => {
    l.warn('UA connecting');
  });

  // соединились с freeswitch
  window.ua.on('connected', () => {
    l.warn('UA connected');
  });

  // freeswitch нас зарегал, теперь можно звонить и принимать звонки
  window.ua.on('registered', () => {
    l.warn('UA registered');
  });

  // freeswitch про нас больше не знает
  window.ua.on('unregistered', () => {
    l.warn('UA unregistered');
  });

  // freeswitch не зарегестрировал нас, скорее всего неверный логин или пароль
  window.ua.on('registrationFailed', (data) => {
    l.error('UA registrationFailed', data.cause);
  });

  // запускаем голосовой канал
  window.ua.start();

  window.ua.on('newRTCSession', (data) => {
    l.log('newRTC Session');
    const { session, request } = data;
    window.sipSession = session;

    if (session.direction === 'incoming' && window.$store.state.calling.online) {
      l.warn('incomingCall');
      incomingCallback();
      session.on('progress', () => {
        l.log('UA session progress');
        playSound('one-day.mp3', true, soundsControl);
      });
      // входящий звонок
      session.on('accepted', () => {
        l.warn('accepted');
        stopSound(soundsControl);
        playSound('answered.mp3', false, soundsControl);
        [remoteAudioControl.srcObject] = session.connection.getRemoteStreams();
        const sessionInfo = {
          sip_operator_id: sipUserPart,
          customer_phone: request.from._display_name,
          call_id: request.call_id,
        };
        answerCallback(sessionInfo);
      });
      session.on('confirmed', (e) => {
        l.warn('confirmed');
      });
      session.on('ended', () => {
        l.warn('Call ended');
        playSound('rejected.mp3', false, soundsControl);
        // звонок закончен
        hangupCallback();
      });
      session.on('failed', () => {
        l.error('session failed');
        stopSound(soundsControl);
        playSound('rejected.mp3', false, soundsControl);
        // unable to establish the call
        hangupCallback();
      });
    } else if (session.direction === 'incoming' && !window.$store.state.calling.online) {
      hangUp();
    }
  });
}

function logout() {
  if (window.ua) {
    window.ua.stop();
    window.$store.dispatch('calling/logoutCallback');
  }
  l.log('on logout');
}

function call({
  number, soundsControl, localAudioControl,
  answerCallback, hangupCallback, remoteAudioControl,
}) {
  window.localStorage.setItem('callNumber', number);

  answerCallback();

  // Делаем ИСХОДЯЩИЙ звонок
  window.sipSession = window.ua.call(number, configuration);

  // freeswitch нас соединил с абонентом
  window.sipSession.on('connecting', () => {
    l.log('UA session connecting');

    // Тут мы подключаемся к микрофону и цепляем к нему поток, который пойдёт в freeswitch
    const peerconnection = window.sipSession.connection;
    const localStream = peerconnection.getLocalStreams()[0];

    // Handle local stream
    if (localStream) {
      // Clone local stream
      localClonedStream = localStream.clone();

      l.log('UA set local stream');

      localAudioControl.srcObject = localClonedStream;
    }
  });

  // В процессе дозвона
  window.sipSession.on('progress', () => {
    l.log('UA session progress');
  });

  // Дозвон завершился неудачно, например, абонент сбросил звонок
  window.sipSession.on('failed', () => {
    l.log('UA session failed');
    stopSound(soundsControl);
    playSound('rejected.mp3', false, soundsControl);

    hangupCallback();
  });

  // Звонок завершен
  window.sipSession.on('ended', () => {
    l.log('UA session ended');
    playSound('rejected.mp3', false, soundsControl);
    JsSIP.Utils.closeMediaStream(localClonedStream);

    hangupCallback();
  });

  // Звонок принят
  window.sipSession.on('accepted', () => {
    l.log('UA session accepted');
    stopSound(soundsControl);
    playSound('answered.mp3', false, soundsControl);
    [remoteAudioControl.srcObject] = window.sipSession.connection.getRemoteStreams();
  });
}

export default {
  call,
  answer,
  hangUp,
  login,
  logout,
};
